import classNames from 'classnames';
import { figcaption } from './FigCaption.css';
import type { FigCaptionProps } from './FigCaption.types';

const FigCaption = ({ children, className }: FigCaptionProps) => {
  return (
    <small className={classNames(className, figcaption)}>
      <p>{children}</p>
    </small>
  );
};

export { FigCaption };
